<template>
    <div class="filters">
        <div class="card">
            <div class="card-header">
                <h3 class="card-title">Liste des véhicules</h3>
                <div class="card-options hide">
                    <a href="#" class="btn btn-primary btn-sm">Exporter</a>
                    <a href="#" class="btn btn-secondary btn-sm ml-2">Importer</a>
                </div>
            </div>
            <el-form ref="filtersForm" :model="filters" label-position="top">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-3">
                            <el-form-item prop="model" label="Modeles">
                                <el-select clearable v-model="filters.model" placeholder="Modeles" filterable>
                                    <el-option v-for="item in models" :key="item" :label="item" :value="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="col-md-3">
                            <el-form-item prop="vehicule_brand_id" label="Marques">
                                <el-select clearable v-model="filters.vehicule_brand_id" placeholder="Marques" filterable>
                                    <el-option v-for="item in vehiculesBrandsOptions" :key="item.id" :label="item.name" :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="col-md-3">
                            <el-form-item prop="year" label="Année">
                                <el-select clearable v-model="filters.year" placeholder="Année" filterable>
                                    <el-option v-for="item in years" :key="item" :label="item" :value="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="col-md-3">
                            <el-form-item prop="cylinder" label="Cylindrée">
                                <el-select clearable v-model="filters.cylinder" placeholder="Cylindrée" filterable>
                                    <el-option v-for="item in cylinders" :key="item" :label="item" :value="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3">
                            <el-form-item prop="hasProducts" label="Produits">
                                <el-radio-group :size="sizeToggleFilter" v-model="filters.hasProducts">
                                    <el-radio-button :label="false">Sans</el-radio-button>
                                    <el-radio-button :label="null">Désactiver</el-radio-button>
                                    <el-radio-button :label="true">Avec</el-radio-button>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="pull-left">
                        <el-dropdown split-button @command="applyAction">
                            Actions groupées
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item :command="item.value" v-for="(item, index) in groupedActionsOptions" :key="index">{{item.label}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <el-checkbox v-model="applyToAllResult">Appliquer à tous les résultats</el-checkbox>

                    </div>

                    <div class="pull-right">
                        <el-button @click="resetFilters" type="info" plain>Annuler</el-button>
                        <el-button @click="validFilters" type="primary">Valider</el-button>
                    </div>

                </div>
            </el-form>
        </div>

        <el-dialog title="Activer / Désactiver" v-loading="modal.activate_desactivate.loader" :visible.sync="modal.activate_desactivate.display" width="50%">
            <span>Activer / Désactiver les {{ items_selected }} marques selectionnés</span>
            <el-form class="row formActive" ref="formActivateDesactivate" :model="modal.activate_desactivate.form">
                <el-form-item prop="activated">
                    <el-switch v-model="modal.activate_desactivate.form.activated" active-text="Activé" inactive-text="Désactivé">
                    </el-switch>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="modal.activate_desactivate.display = false">Annuler</el-button>
                <el-button type="primary" @click="changeActivateDesactivate">Enregistrer</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
import { EventBus } from '../../event-bus';
import Vehicule from '../../models/Vehicule';

export default {
    data() {
        return {
            brandsOptions: [],
            categoriesOptions: [],
            manufacturersOptions: [],
            vehiculesBrandsOptions: [],
            sizeToggleFilter: 'mini',
            filters: {
                brand_id: '',
                manufacturer_id: '',
                category_id: [],
                queryAutocomplete: null,
                hasProducts: null
            },
            groupedActionsOptions: [
                {
                    label: 'Activer / Désactiver',
                    value: 'activate_desactivate'
                }
            ],
            groupedActionsValue: '',
            modal: {
                activate_desactivate: {
                    display: false,
                    loader: false,
                    form: {
                        activated: false
                    }
                },
                activate_desactivate_vehiculier: {
                    display: false,
                    loader: false,
                    form: {
                        activated: false
                    }
                }
            }
        };
    },
    props: {
        selected: {
            default() {
                return [];
            }
        }
    },
    computed: {
        q: {
            get() {
                return this.$store.getters['app/q'];
            },
            set(value) {
                this.$store.dispatch('app/setQ', value);
            }
        },
        cylinders() {
            return this.$store.getters['vehicules/cylinders'];
        },
        years() {
            return this.$store.getters['vehicules/years'];
        },
        models() {
            return this.$store.getters['vehicules/models'];
        },
        total_item() {
            return this.$store.getters['vehicules/totalItems'];
        },
        items_selected() {
            return this.applyToAllResult
                ? this.total_item
                : this.selected.length;
        },
        applyToAllResult: {
            get() {
                return this.$store.getters['vehicules/applyToAllResults'];
            },
            set(value) {
                this.$store.dispatch('vehicules/setApplyToAllResults', value);
            }
        }
    },
    mounted() {
        axios.get('/manufacturers').then(r => {
            this.manufacturersOptions = r.data.data;
        });
        axios.get('/vehicules-brands').then(r => {
            this.vehiculesBrandsOptions = r.data.data;
        });
        EventBus.$on('search-input.submit', () => {
            this.validFilters();
        });
    },
    methods: {
        resetFilters() {
            this.$refs.filtersForm.resetFields();
            this.$store.dispatch('app/setQ', null);
            this.validFilters();
        },

        validFilters() {
            var filters = {};
            this.filters.q = this.q;
            var exclude = ['applyToAllResult'];
            for (let filter in this.filters) {
                var value = this.filters[filter];
                if (exclude.indexOf(filter) == -1) {
                    switch (typeof value) {
                        case 'object':
                            if (value !== null && value.length) {
                                filters[filter] = value;
                            }
                            break;

                        default:
                            if (value !== null && value !== '') {
                                filters[filter] = value;
                            }
                            break;
                    }
                }
            }
            this.$emit('update-filters', filters);
        },
        setFilter(filter_name, value, noValidate) {
            this.filters[filter_name] = value;
            if (!noValidate) {
                this.validFilters();
            }
        },
        applyAction(v) {
            if (!this.selected.length && !this.applyToAllResult) return;
            switch (v) {
                case 'activate_desactivate':
                    this.modal.activate_desactivate.display = true;
                    break;

                default:
                    break;
            }
        },

        changeActivateDesactivate() {
            var activated = this.modal.activate_desactivate.form.activated;
            var vehicules = this.selected.map(v => v.id);
            this.modal.activate_desactivate.loader = true;
            var datas = {
                vehicules,
                activated,
                mode: 'activate_desactivate'
            };
            if (this.applyToAllResult) {
                datas.filters = this.filters;
            }
            axios
                .post('/vehicules/bulk', datas)
                .then(r => {
                    this.$emit('vehiculesUpdated', Vehicule.build(r.data.data));
                    this.$refs.formActivateDesactivate.resetFields();
                    this.modal.activate_desactivate.display = false;
                    this.applyToAllResult = false;
                })
                .catch(() => {})
                .then(() => {
                    this.modal.activate_desactivate.loader = false;
                });
        }
    }
};
</script>
<style lang="scss">
.el-form {
    .card-footer {
        text-align: initial;
        .pull-right {
            text-align: center;
        }
    }
}
</style>
